import { TradingViewTimeframesEnum } from '@modules/trading-view-module/enums/trading-view-timeframes.enum'

export const LongLoadingTimeframes: TradingViewTimeframesEnum[] = [
	TradingViewTimeframesEnum.oneHour,
	TradingViewTimeframesEnum.twoHours,
	TradingViewTimeframesEnum.threeHours,
	TradingViewTimeframesEnum.fourHours,
]
